import { render } from "./Bar-chart-legend-card.vue?vue&type=template&id=4666e970"
import script from "./Bar-chart-legend-card.vue?vue&type=script&lang=js"
export * from "./Bar-chart-legend-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/charts/Bar-chart-legend-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4666e970"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4666e970', __exports__)) {
    api.reload('4666e970', __exports__)
  }
  
  module.hot.accept("./Bar-chart-legend-card.vue?vue&type=template&id=4666e970", () => {
    api.rerender('4666e970', render)
  })

}


export default __exports__